import clsx from "clsx"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import { useHistory } from "react-router"

const DocCard = ({ doc }) => {
  const history = useHistory()
  return (
    <div
      role="button"
      tabIndex={0}
      key={doc?.id}
      className={clsx(
        "w-[300px] relative h-[350px] bg-white docs-card-shadow rounded-xl flex flex-col hover:hover-card-shadow cursor-pointer animated-arrow-parent transition-all duration-300 hover:scale-[101%]",
      )}
      onClick={() => history.push(`/documents/${doc.id}/details`)}
      onKeyDown={(e) => {
        if (e.key === "Enter") history.push(`/documents/${doc.id}/details`)
      }}
    >
      {!isEmpty(JSON.parse(doc.card_image)) && (
        <div className="absolute right-5 top-5 flex h-[40px] w-[40px] items-center justify-center rounded-full bg-white p-2">
          <img
            src={JSON.parse(doc.card_image)?.secure_url}
            className="my-0"
            alt="Partner Logo"
          />
        </div>
      )}
      <div className="rounded-tr-xl rounded-tl-xl min-h-[150px]">
        {!isEmpty(JSON.parse(doc.image)) ? (
          <img
            src={JSON.parse(doc.image)?.secure_url}
            className="w-full my-0 rounded-tr-xl rounded-tl-xl aspect-video object-contain"
            alt={doc?.name + "course"}
          />
        ) : (
          <div className="bg-primary h-[170px] my-0 rounded-tr-xl rounded-tl-xl aspect-video object-contain" />
        )}
      </div>
      <div className="p-6 h-full flex flex-col">
        <div className="flex text-primary text-sm mb-2">
          <span className="uppercase">{doc?.type}</span>
          <span className="mx-2 font-semibold">·</span>
          <span> {doc?.minutes_to_read} min read</span>
        </div>
        <div className="flex-grow mb-8" tabIndex={-1}>
          <p className="mt-0 text-xl sm:text-2xl mb-0 flex-grow leading-tight font-archivo font-semibold">
            {doc?.name?.length > 30
              ? doc?.name?.slice(0, 30) + "..."
              : doc?.name}
          </p>
        </div>

        <div className="font-semibold flex items-center no-underline hover:no-underline">
          <span className="text-lg font-archivo">Learn more</span>
          <svg className="animated-arrow" fill="#5300EC">
            <path d="M0.25 4.67886H10.4978L7.10005 1.1497L8.2067 0L13.5 5.5L8.2067 11L7.10005 9.8506L10.4978 6.32144H0.25V4.67886Z" />
          </svg>
        </div>
      </div>
    </div>
  )
}

DocCard.propTypes = {
  doc: PropTypes.object,
}

export default DocCard
